import { render, staticRenderFns } from "./GenerateLayout.vue?vue&type=template&id=0fbf5f9c&scoped=true&"
import script from "./GenerateLayout.vue?vue&type=script&lang=js&"
export * from "./GenerateLayout.vue?vue&type=script&lang=js&"
import style0 from "./GenerateLayout.vue?vue&type=style&index=0&id=0fbf5f9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf5f9c",
  null
  
)

export default component.exports